export default "__VITE_ASSET__D88f90wA__"